var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect, useContext, createContext } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import { getAuth } from 'firebase/auth';
import { getApp } from 'firebase/app';
import { useAuthState } from 'react-firebase-hooks/auth';
var useProvideAuth = function () {
    var _a = useAuthState(getAuth(getApp())), user = _a[0], initialising = _a[1], error = _a[2];
    var _b = useState({ name: '', number: '' }), userData = _b[0], setUserData = _b[1];
    var signIn = function (email, password) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebase.auth().signInWithEmailAndPassword(email, password)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var signInAnonymously = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebase.auth().signInAnonymously()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var signOut = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebase.auth().signOut()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getUserData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var userRef, userDoc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!user) return [3 /*break*/, 2];
                    userRef = firebase.firestore().collection('guests').doc(user.uid);
                    return [4 /*yield*/, userRef.get()];
                case 1:
                    userDoc = _a.sent();
                    userDoc.data() &&
                        setUserData({
                            name: userDoc.data().name,
                            number: userDoc.data().number
                        });
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var setNumber = function (number) { return __awaiter(void 0, void 0, void 0, function () {
        var userRef, userDoc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(user && number.length === 4)) return [3 /*break*/, 2];
                    userRef = firebase.firestore().collection('guests').doc(user.uid);
                    return [4 /*yield*/, userRef.set({ number: number }, { merge: true })];
                case 1:
                    userDoc = _a.sent();
                    getUserData();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var setName = function (name) { return __awaiter(void 0, void 0, void 0, function () {
        var userRef, userDoc;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(user && name)) return [3 /*break*/, 2];
                    userRef = firebase.firestore().collection('guests').doc(user.uid);
                    return [4 /*yield*/, userRef.set({ name: name }, { merge: true })];
                case 1:
                    userDoc = _a.sent();
                    getUserData();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getUserData();
    }, [initialising]);
    return {
        user: user,
        initialising: initialising,
        error: error,
        userData: userData,
        signIn: signIn,
        signInAnonymously: signInAnonymously,
        signOut: signOut,
        setNumber: setNumber,
        setName: setName
    };
};
var authContext = createContext({});
export var AuthProvider = function (_a) {
    var children = _a.children;
    var auth = useProvideAuth();
    return React.createElement(authContext.Provider, { value: auth }, children);
};
export var useAuth = function () {
    return useContext(authContext);
};
